import { render } from "./QRRequestAdmin.vue?vue&type=template&id=3888e922"
import script from "./QRRequestAdmin.vue?vue&type=script&lang=js"
export * from "./QRRequestAdmin.vue?vue&type=script&lang=js"

import "./QRRequestAdmin.vue?vue&type=style&index=0&id=3888e922&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__